import React from 'react';
import {
    Grid,
    Divider,
    Box,
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    Button
} from "@material-ui/core";

import { titleTab, useStyles } from "app/c1utils/styles";
import PageviewIcon from '@material-ui/icons/Pageview';
import IconButton from "@material-ui/core/IconButton";
import { previewPDF } from "app/c1utils/utility";
import Checkbox from '@material-ui/core/Checkbox';

const RaeoAppDigitalMou = ({
    inputData,
    handleInputChange,
    handleDateChange,
    viewType,
    errors,
    isSubmitting }) => {

    let isDisabled = true;
    const classes = useStyles();
    const titleClasses = titleTab();

    if (viewType === 'new')
        isDisabled = false;
    else if (viewType === 'edit')
        isDisabled = false;
    else if (viewType === 'view')
        isDisabled = true;

    if (isSubmitting || inputData.status !== 'Approved')
        isDisabled = true;

    const viewFile = (fileName, data) => {
        console.log("fileName", fileName, data);
        previewPDF(fileName + ".pdf", data);
    };

    const [checked, setChecked] = React.useState(false);
    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    console.log("inputData?.appMou:", inputData?.appMou);
    //const dataUrl = `data:application/pdf;base64,${Buffer.from(inputData?.appMou).toString('base64')}`;
    const dataUrl = `data:application/pdf;base64,${inputData?.appMou}`;

    const routeMou = (isAccept) => {

    }

    return (
        <React.Fragment>

            <Grid item lg={12} md={12} xs={12}>
                <Grid container alignItems="center" spacing={3} className={classes.gridContainer}>
                    <Grid container item xs={12} className={titleClasses.root}>
                        MOU
                        <Divider className="mb-6" />
                    </Grid>
                </Grid>
            </Grid>
            
            {( inputData.appWkflStatus === 'Approved' ) &&
                <Box  className="m-2">
                <FormControl component="fieldset" >
                    <FormLabel component="legend"></FormLabel>
                    <FormGroup>
                    <FormControlLabel
                        control={<Checkbox checked={checked} onChange={handleChange} name="gilad" />}
                        label="I read and understood MOU"
                    />
                    </FormGroup>
                    <FormGroup row>
                    <FormControlLabel
                        control={<Button variant="contained"
                        color="secondary"
                        size="large"
                        fullWidth
                        disabled={!checked}
                        onClick={(e) => routeMou(true)}>Accept MOU</Button>}
                        label="" />
                    <FormControlLabel
                        control={<Button variant="contained"
                        color="secondary"
                        size="large"
                        fullWidth
                        disabled={!checked}
                        onClick={(e) => routeMou(false)}>Reject MOU</Button>}
                        label=""/>
                    </FormGroup>
                </FormControl>
                </Box>}
            {(inputData.appWkflStatus === 'Approved' || inputData.appWkflStatus === 'Activated') &&
                <Box  className="m-2 FullHeight">


                   { false && <div>
                        View MOU
                        <IconButton aria-label="Preview" type="button"
                            color="primary" onClick={(e) => viewFile(inputData.appId, inputData.appMou)}>
                            <PageviewIcon />
                        </IconButton>
                    </div> }
                    <iframe
                        title="PDF Viewer"
                        src={dataUrl}
                        style={{ width: '100%', height: '100%', border: 'none' }}>
                    </iframe>
                </Box>}
            <br/>
        </React.Fragment>
    );
};

export default RaeoAppDigitalMou;